import { render, staticRenderFns } from "./OcorrenciaIntegracaoErro.vue?vue&type=template&id=28863a89"
import script from "./OcorrenciaIntegracaoErro.vue?vue&type=script&lang=js"
export * from "./OcorrenciaIntegracaoErro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports